/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { FeatureCardsSectionFragment } from "@cosmos/hygraph-schema";

import { ResponsiveContainer, SectionHeading, BackgroundContainer, SectionContainer } from "@components/elements";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { VStack } from "@panda/jsx";

import { FeatureCards } from "./FeatureCards.organism";

export const FeatureCardsSection = ({
	config,
	cards,
	tags,
	tagListTitle,
}: FeatureCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length || tags?.length || tagListTitle);
	if (!validHeading && !validContent) return null;

	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="feature-cards-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<FeatureCards cards={cards || []} tags={tags || []} tagListTitle={tagListTitle || ""} />
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
